import Vue from "vue";

export default class CompanyService {
  constructor() {}

  async loginUnderCompany(companyId) {
    var response = await Vue.prototype.$client.post(
      "/api/auth/loginFromCompany",
      {
        id: companyId,
      }
    );

    if (response.data.isSuccess) {
      var loginDto = response.data.value;

      Vue.prototype.$localStorageService.setItem(
        "name",
        loginDto.userFirstLastName
      );

      Vue.prototype.$localStorageService.setItem("email", loginDto.userEmail);

      Vue.prototype.$localStorageService.setItem("companyId", companyId);

      Vue.prototype.$localStorageService.setItem(
        "businessId",
        loginDto.businessId
      );

      Vue.prototype.$localStorageService.setItem(
        "config",
        JSON.stringify({ roles: loginDto.roles })
      );

      Vue.prototype.$localStorageService.setItem(
        "system",
        JSON.stringify(loginDto.system)
      );

      Vue.prototype.$localStorageService.setItem("avatar", loginDto.avatar);

      Vue.prototype.$localStorageService.setItem("poyntAppId", loginDto.appId);

      Vue.prototype.$localStorageService.setItem(
        "companyName",
        loginDto.companyName
      );

      Vue.prototype.$localStorageService.setItem("isAdmin", true);
      Vue.prototype.$localStorageService.setItem("app", "dashboard");

      Vue.prototype.$localStorageService.removeItem("terminals");

      Vue.prototype.$localStorageService.setItem(
        "companyPhone",
        loginDto.companyPhone
      );

      var tokenObj = {
        access_token: response.data.value.token,
        refresh_token: response.data.value.refreshToken,
      };

      Vue.prototype.$localStorageService.setToken(tokenObj);

      location.href = "/#/dashboard";

      return true;
    }
  }
}
